import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import gearIcon from 'public/icons/gear.svg';
import iconIndicator from 'public/icons/icon-indicator-dot-red.svg';
import styles from './gear-icon.less';

const cx = classnames.bind(styles);

const GearIcon = ({ showIndicator }) => (
  <div className={styles.GearIcon}>
    <img className={styles.Icon} src={gearIcon} alt="gearIcon" />
    <img
      className={cx(styles.Indicator, {
        [styles.Hidden]: !showIndicator,
      })}
      src={iconIndicator}
      alt={'red-dot'}
    />
  </div>
);

GearIcon.propTypes = {
  showIndicator: PropTypes.bool,
};

GearIcon.defaultProps = {
  showIndicator: false,
};

export default GearIcon;
